import React, { useEffect } from 'react';

import { NotificationManager, StorageManager, useApplicationState } from '@atlas/core';

import { TERMINAL_LOGIN_UID_STORAGE_KEY } from 'common/constants';
import dayjs from 'dayjs';

const getTerminalLoginNotificationConfig = sessionUid => ({
  data: {
    sessionUid,
  },
  id: 'terminalLoginPopup',
  type: 'terminalLoginPopup',
});

const getStorageConfig = () => {
  let storageSessionUidConfig = StorageManager.getItem(TERMINAL_LOGIN_UID_STORAGE_KEY);
  try {
    if (storageSessionUidConfig) {
      storageSessionUidConfig = JSON.parse(storageSessionUidConfig);
    }
  } catch (e) {
    console.error(e);
  }
  return storageSessionUidConfig;
};

export const getTerminalLoginConfig = () => {
  const storageSessionUidConfig = getStorageConfig();
  if (
    storageSessionUidConfig?.sessionUid &&
    storageSessionUidConfig?.finishTime > dayjs().valueOf()
  ) {
    return getTerminalLoginNotificationConfig(storageSessionUidConfig.sessionUid);
  }

  return null;
};

export const TerminalLoginPopupManager = () => {
  const { authenticated, resolved } = useApplicationState();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionUid = params.get('sessionUid');
    const storageSessionUidConfig = getStorageConfig();

    if (
      sessionUid &&
      (!storageSessionUidConfig || storageSessionUidConfig?.sessionUid !== sessionUid)
    ) {
      StorageManager.setItem(
        TERMINAL_LOGIN_UID_STORAGE_KEY,
        JSON.stringify({
          finishTime: dayjs()
            .add(params.get('sessionUidTtl') || 160, 's')
            .valueOf(),
          sessionUid,
        }),
      );
    }
  }, []);

  useEffect(() => {
    if (resolved && authenticated) {
      const notificationConfig = getTerminalLoginConfig();
      if (notificationConfig) NotificationManager.display(notificationConfig);
    }
  }, [authenticated, resolved]);

  return null;
};
